<template>
  <div class="payment__content">
    <!-- header -->
    <div class="layer__header" v-if="orderType != 'F'">
      <div class="lyr-title">{{ $t('User.BellMobile.msg1') }}</div>
      <div class="ft-point">{{ $t('User.BellMobile.msg2') }}</div>
      <div class="lyr-txt">{{ $t('User.BellMobile.msg3') }}</div>
    </div>
    <div class="layer__header" v-else>
      <div class="lyr-title">{{ $t('User.BellMobile.msg1') }}</div>
      <div class="ft-point">{{ $t('User.BellMobile.msg12') }}</div>
      <div class="lyr-txt">{{ $t('User.BellMobile.msg13') }}</div>
    </div>
    <!-- //header -->

    <div class="payment__body">
      <div class="inner-pd">
        <div class="input-area">
          <label for="">{{ $t('User.BellMobile.msg4') }}</label>
          <input type="text" v-if="!eyeActive" :placeholder="$t('User.BellMobile.msg5')" :value="reciptData" />
          <input type="text" v-if="eyeActive" :placeholder="$t('User.BellMobile.msg5')" :value="orgReciptData" />
          <button class="btn-eye" :class="{masking: !eyeActive}" @mouseup="eyeActive = eyeActive ? false : true"></button>
          <!-- <button class="btn-eye masking"></button> -->
        </div>
        <div class="keypad-wrap">
          <div class="keypad keypad--white">
            <button class="btn-anim" @mouseup="setRecipt(1)">1</button>
            <button class="btn-anim" @mouseup="setRecipt(2)">2</button>
            <button class="btn-anim" @mouseup="setRecipt(3)">3</button>
            <button class="btn-anim" @mouseup="setRecipt(4)">4</button>
            <button class="btn-anim" @mouseup="setRecipt(5)">5</button>
            <button class="btn-anim" @mouseup="setRecipt(6)">6</button>
            <button class="btn-anim" @mouseup="setRecipt(7)">7</button>
            <button class="btn-anim" @mouseup="setRecipt(8)">8</button>
            <button class="btn-anim" @mouseup="setRecipt(9)">9</button>
            <button @mouseup="setRecipt(10)" class="delete btn-anim">{{ $t('User.BellMobile.msg8') }}</button>
            <button class="btn-anim" @mouseup="setRecipt(0)">0</button>
            <button @mouseup="setRecipt(-1)" class="btn-back btn-anim">삭제</button>
          </div>
        </div>
        <div class="txt-tip center">{{ $t('User.BellMobile.msg9') }}</div>
      </div>
    </div>

    <div class="layer__button">
      <button class="btn btn--half btn--cancel btn-anim" v-if="usePager" @mouseup="$emit('closeBellMobile')">{{ $t('User.BellMobile.msg6') }}</button>
      <button class="btn btn--half btn--cancel btn-anim" v-if="orderType == 'F'" @mouseup="$emit('setMobileFinish', 'skip')">
        {{ $t('Modal.MenuEvent.msg5') }}
      </button>
      <button
        id="compBtn"
        class="btn btn--submit btn-anim"
        @mouseup="
          alramYn = true;
          $emit('setMobileFinish', orgReciptData);
          $logInfo(`Mobile Finish Number : ${orgReciptData}`);
        "
        :class="[orgReciptData.length < 11 ? 'btn--disabled' : 'btn--color']"
        :disabled="orgReciptData.length < 11 || alramYn"
      >
        {{ $t('User.BellMobile.msg7') }}
      </button>
    </div>
  </div>
</template>

<script>
import audioHelper from '@/js/common/audioHelper.js';

export default {
  name: 'bellMobile',
  props: {},
  data() {
    return {
      reciptData: '',
      orgReciptData: '',
      darkModeYn: this.$store.getters.getDarkModeYn,
      eyeActive: false,
      useAlarmTalk: this.$store.getters.getPosConfig.posConfig.useAlarmTalk,
      usePager: this.$store.getters.getPosConfig.posConfig.usePager,
      orderType: this.$store.getters.getPosConfig.posConfig.templateNo,
      alramYn: false,
    };
  },
  mounted() {},
  components: {},
  methods: {
    setRecipt(num) {
      if (num == 10) {
        this.orgReciptData = '';
        this.alramYn = false;
      } else if (num < 0) {
        this.orgReciptData = this.orgReciptData.slice(0, -1);
        this.alramYn = false;
      } else if (this.orgReciptData.length < 11) this.orgReciptData += num + '';

      var str = this.orgReciptData.split('');
      for (let i = 0; i < str.length; i++) {
        if (i >= 3 && i <= 6) {
          str[i] = '*';
        }
      }

      this.reciptData = str.join('');
      // if (this.orgReciptData.length > 7) this.reciptData = this.orgReciptData.slice(0, 7) + '*'.repeat(this.orgReciptData.length - 7);
      // else this.reciptData = this.orgReciptData;
    },
  },
  computed: {
    darkMode: function () {
      return this.$store.getters.getDarkModeYn;
    },
  },
  watch: {
    darkMode() {
      this.darkModeYn = this.darkModeYn ? false : true;

      this.$changeDarkMode(this.darkModeYn);
    },
  },
};
</script>

<style src="@/assets/css/user/common.css" scoped></style>
<style src="@/assets/css/user/pages/payment.css" scoped></style>
<style src="@/assets/css/user/pages/keypad.css" scoped></style>
<style src="@/assets/css/user/dark/common-dark.css" scoped></style>
<style src="@/assets/css/user/dark/payment-dark.css" scoped></style>
<style src="@/assets/css/user/dark/keypad-dark.css" scoped></style>
<style scoped>
.payment__body {
  height: 51vh;
}

.keypad-wrap {
  width: 39vw;
  margin: 6.3vh auto 0;
}

.keypad.keypad--white button {
  width: 11.2vw;
  height: 11.2vw;
}

.txt-tip {
  margin-top: 3.6vh;
}
</style>
